import type { MouseEventHandler, PropsWithChildren } from 'react';

import { useFormContext } from '#/components/Form/FormContext';

import { SubmitBaseButton } from './SubmitBaseButton';

type Props = PropsWithChildren<{
  qaId?: string;
  size?: 'small' | 'medium' | 'large';
  type?: 'submit' | 'button';
  onClick?: MouseEventHandler;
}>;

export function SecondarySubmitButton({
  qaId,
  size,
  type,
  onClick,
  children,
}: Props) {
  const { fieldQaIdPrefix, submitting, submitDisabled } = useFormContext();

  return (
    <SubmitBaseButton
      type={type}
      variant="secondary"
      size={size}
      qaId={fieldQaIdPrefix && qaId ? `${fieldQaIdPrefix}-${qaId}` : qaId}
      submitting={submitting}
      submitDisabled={submitDisabled}
      onClick={onClick}
    >
      {children}
    </SubmitBaseButton>
  );
}
